<template lang="pug">
.base.mb-4.mt-4
  .form-check.me-3(v-if='enableGeneratePDFA')
    input#flexCheckDefault.form-check-input(
      :checked='typePDFA'
      @change='$emit("generatePDFA", $event.target.checked)'
      type='checkbox'
    )
    label.form-check-label(for='flexCheckDefault') Gerar PDF/A
    span.help.px-2(v-tooltip:right='tooltipPDFA')
      icon.fs-6(name='circle-question')
  .form-check.me-3(v-if='enableSaveTemplate')
    input#flexCheckDefault.form-check-input(
      @change='$emit("save-template", $event.target.checked)'
      type='checkbox'
    )
    label.form-check-label(for='flexCheckDefault') {{ $t('modal.envelope.saveAsTemplate') }}
  .me-3
    button.btn.btn-thin.btn-thin--envelope-bottom(@click='saveAndClose')
      span.text {{ $t('modal.envelope.saveAndClose') }}
  div
    button.btn.btn-primary(:disabled='disableButtonNextStep' @click='nextStep')
      span.text {{ textButtonNextStep || $t('modal.envelope.next') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'EnvelopeBottom',
  components: {
    Icon,
  },
  props: {
    enableGeneratePDFA: {
      type: Boolean,
      default: false,
    },
    typePDFA: {
      type: Boolean,
      default: false,
    },
    enableSaveTemplate: {
      type: Boolean,
      default: false,
    },
    textButtonNextStep: {
      type: String,
      default: '',
    },
    disableButtonNextStep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipPDFA:
        'PDF/A é um formato de arquivo padronizado para preservar documentos digitais a longo prazo.\
        <br>Ao ativar essa opção a configuração de campos nos documentos será\
        limitada para atender aos requisitos do PDF/A.',
    };
  },
  methods: {
    saveAndClose() {
      this.$emit('saveAndClose');
    },
    nextStep() {
      this.$emit('nextStep');
    },
  },
};
</script>
<style lang="stylus">
.base
  height: 70px
  display: flex
  vertical-align: middle
  flex-direction: row
  width: inherit
  align-items: center
  justify-content: flex-end
.form-check
  color: #063D52
</style>
